import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  formatPrice,
  getLicenseDuration,
  getLicensingDuration,
  getLicensePrice,
  addDefaultSrc,
} from "../../../utilities";
import { identifyUrl } from "../../../Pages/Video/video_actions";
import RequestMessageSent from "./_license_request_sent";
import RequestMessageReceived from "./_license_request_received";
import GenerateTiktokThumbnail from "../../GenerateTiktokThumbnail";

export default ({
  message,
  agreement: {
    license_agreement: {
      influencer_royalties,
      total_price,
      duration,
      purchased_at,
    },
    license_video: { _id: video_id, thumbnail_url, title, platform, video_url },
    influencer_video_note: note,
  },
  status,
  isRequester,
  user,
  acceptAgreement,
}) => {
  const [poster, setPoster] = useState(true);
  const urlUpdate = {
    "www.dropbox.com": "dl.dropboxusercontent.com",
    "dl=0": "raw=1#t=3",
  };
  const dropboxUrl = video_url.replace(
    /\b(?:www.dropbox.com|dl=0)\b/gi,
    (matched) => urlUpdate[matched]
  );
  const handleUrl = (url) => {
    identifyUrl(url)
      .then((response) => {
        if (response) {
          setPoster(true);
        }
      })
      .catch((err) => {
        if (err.status === 404) {
          setPoster(false);
        }
      });
  };

  return (
    <div>
      <div className="license-header">
        <i className="icon-handshake" />
        <h3>{isRequester ? "License Request Sent" : "License Request"}</h3>
        <p>
          {isRequester
            ? `${user.first_name} has received the request and should respond within 72 hours.`
            : `Congrats! ${user.first_name} ${user.last_name} wants to license your video. Please try to respond within 72 hours.`}
        </p>
      </div>
      <pre>{message}</pre>
      <Link className="license-thumbnail" to={`/videos/${video_id}`}>
        {platform === "Dropbox" && video_url && (
          <>
            {handleUrl(dropboxUrl)}
            <video
              width="10%"
              poster={poster ? undefined : "assets/dropbox-deleted.png"}
            >
              <source src={dropboxUrl} />
            </video>
          </>
        )}{" "}
        {platform === "Youtube" && video_url && (
          <img src={thumbnail_url} onError={(event) => addDefaultSrc(event)} />
        )}
        {video_url && platform === "Tiktok" && (
          <div className="LicenseRequest-VideoWrapper">
            <GenerateTiktokThumbnail
              video={{ video_url: video_url }}
              customStyle={{
                display: "flex",
                justifyContent: "center",
                background: "black",
                width: "150px",
              }}
              imgStyle={{
                objectFit: "contain",
                maxHeight: "100px",
              }}
            />
          </div>
        )}
        <span>{title}</span>
      </Link>
      {status === "PENDING" ? (
        <div className="license-settings">
          <span className="license-duration">{`${getLicenseDuration(
            note
          )} license`}</span>
          <span className="license-price">
            {formatPrice(getLicensePrice(note))}
          </span>
        </div>
      ) : (
        <div className="license-settings">
          <span className="license-duration">
            {`${
              duration
                ? getLicensingDuration(duration)
                : getLicenseDuration(note)
            } license`}
          </span>
          <span className="license-price">
            {formatPrice(influencer_royalties)}
          </span>
        </div>
      )}
      {isRequester ? (
        <RequestMessageSent
          status={status}
          note={note}
          royalties={influencer_royalties}
          totalPrice={total_price}
        />
      ) : (
        <RequestMessageReceived
          status={status}
          user={user}
          note={note}
          acceptAgreement={acceptAgreement}
          royalties={influencer_royalties}
        />
      )}
    </div>
  );
};
